import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inner-wrapper" }
const _hoisted_2 = { class: "buy-for-section" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = { class: "how-long" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "promocode-container" }
const _hoisted_8 = {
  key: 0,
  class: "promo-error"
}
const _hoisted_9 = {
  key: 0,
  class: "auto-recharge"
}
const _hoisted_10 = { class: "auto-recharge__head" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "spinner"
}
const _hoisted_13 = {
  key: 1,
  class: "submit-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_purchase_packs_component = _resolveComponent("purchase-packs-component")!
  const _component_rate_finder = _resolveComponent("rate-finder")!
  const _component_promo_code = _resolveComponent("promo-code")!
  const _component_ToggleComponent = _resolveComponent("ToggleComponent")!
  const _component_spinner_component = _resolveComponent("spinner-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.packId)
      ? (_openBlock(), _createBlock(_component_purchase_packs_component, {
          key: 0,
          packs: _ctx.packs,
          "selected-pack-id": _ctx.packId,
          "onUpdate:selectedPackId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.packId) = $event)),
          extra: _ctx.extra
        }, null, 8, ["packs", "selected-pack-id", "extra"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('rateFinder.buyingFor')), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["flag", [_ctx.country ? `flag:${_ctx.country.code}` : '']])
        }, null, 2),
        _createElementVNode("p", {
          class: "header-phone-number",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePhoneNumber && _ctx.changePhoneNumber(...args)))
        }, "+" + _toDisplayString(_ctx.phoneNumber), 1)
      ]),
      _createElementVNode("p", _hoisted_4, [
        (_ctx.promoExtra)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('buyCredit.howLongWouldXPlusLast', { amount: _ctx.selectedPack?.formatted, extra: _ctx.promoExtra })), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('buyCredit.howLongWouldXLast', { amount: _ctx.selectedPack?.formatted })), 1))
      ]),
      _createVNode(_component_rate_finder, {
        showRateListCard: false,
        defaultCountry: _ctx.country.code,
        defaultCurrency: _ctx.packs.currency,
        amount: _ctx.selectedPack?.amount,
        extra: _ctx.extra
      }, null, 8, ["defaultCountry", "defaultCurrency", "amount", "extra"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_promo_code, {
          onApply: _ctx.applyPromocode,
          modelValue: _ctx.promoCodeValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.promoCodeValue) = $event)),
          expanded: _ctx.expandPromocode,
          "onUpdate:expanded": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.expandPromocode) = $event)),
          applied: !!_ctx.extra && !_ctx.promoError,
          isLoading: _ctx.isPromocodeLoading
        }, null, 8, ["onApply", "modelValue", "expanded", "applied", "isLoading"]),
        (_ctx.promoError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('promocodeError')), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.autoRechargeShow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('autoRecharge.label')), 1),
              _createVNode(_component_ToggleComponent, {
                checked: _ctx.autoRecharge,
                disabled: !!_ctx.selectedPack && !_ctx.selectedPack.allow_recurring,
                "onUpdate:checked": _ctx.changeAutoRecharge
              }, null, 8, ["checked", "disabled", "onUpdate:checked"])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('autoRecharge.subtext')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "submit-order",
        type: "button",
        disabled: !_ctx.packId || _ctx.isLoading,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('buyCredit.buyXNow', { amount: _ctx.selectedPack?.formatted })) + " ", 1),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
              _createVNode(_component_spinner_component)
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_11),
      (_ctx.submitError)
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('submitError')), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}